import { render, staticRenderFns } from "./homePart3.vue?vue&type=template&id=64b4f79e&scoped=true&"
import script from "./homePart3.vue?vue&type=script&lang=js&"
export * from "./homePart3.vue?vue&type=script&lang=js&"
import style0 from "./homePart3.vue?vue&type=style&index=0&id=64b4f79e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b4f79e",
  null
  
)

export default component.exports